/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Style from './style';
import Widget from '../../widget';
import useMonthlyProgress from './helper';
import { useResizeContext } from 'datastake-daf/dist/context';

const Chart = () => {
  const container = useRef();
  useMonthlyProgress({ container });

  return <Style ref={container} />;
}

export default function MonthlyProgress() {
  const [show, setShow] = useState(false);
  const { t } = useTranslation();
  const { isCollapsed } = useResizeContext();

  useEffect(() => {
    if (show) {
      setShow(false);
      setTimeout(() => setShow(true), 100);
    } else {
      setShow(true);
    }
  }, [isCollapsed]);

  return (
    <Widget
      className="with-border-header no-px overflow-hidden no-pb-body"
      title={t('Monthly Progress')}
    >
      <div className='flex flex-1 flex-column justify-content-center'>
        <div className='flex justify-content-center'>
          {/* {show ? <Chart /> : null} */}
          <Chart />
        </div>
      </div>
    </Widget>
  )
}
